import React, { useState, useEffect } from 'react';

const Navigation = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Bottom Navigation Bar - Shows on scroll */}
      <nav className={`fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        <div className="bg-black rounded-full px-4 py-2 flex items-center gap-3 shadow-2xl" style={{ transform: 'translateZ(50px)' }}>
          <button
            onClick={() => scrollToSection('hero')}
            className="text-white hover:text-orange-500 transition-all duration-300 text-sm font-medium px-3 py-2 hover:scale-110"
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('skills')}
            className="text-white hover:text-orange-500 transition-all duration-300 text-sm font-medium px-3 py-2 hover:scale-110"
          >
            Skills
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className="text-white hover:text-orange-500 transition-all duration-300 text-sm font-medium px-3 py-2 hover:scale-110"
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('portfolio')}
            className="text-white hover:text-orange-500 transition-all duration-300 text-sm font-medium px-3 py-2 hover:scale-110"
          >
            Portfolio
          </button>
          <button
            onClick={() => scrollToSection('testimonials')}
            className="text-white hover:text-orange-500 transition-all duration-300 text-sm font-medium px-3 py-2 hover:scale-110"
          >
            Reviews
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-full transition-all duration-300 text-sm font-semibold hover:scale-110"
          >
            Contact me
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navigation;